import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { listOfProduct, listOfProductsType } from '../../types/slices/listOfProductsType'

const initialState: listOfProductsType =
{
    status: ApiStatus.FETCHED,
    listOfProducts: [],
    listProductSelected: {} as listOfProduct,
    errorMessage: undefined,
    action: ''
}

const listOfProductsSlice = createSlice({
    name: 'listOfProductsSlice',
    initialState,
    reducers: {
        onFetchListOfProducts (state, { payload }: { payload: listOfProduct[]}) {
            state.status = ApiStatus.FETCHED
            state.listOfProducts = payload
            state.errorMessage = undefined
        },
        onSetSelectedListOfProduct (state, { payload }: { payload: listOfProduct }) {
            state.listProductSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectListProductState = (state: RootState) => state.listOfProductsSlice
export default listOfProductsSlice.reducer
export const {
    onFetchListOfProducts,
    onSetSelectedListOfProduct,
    changeStatus,
    setAction,
} = listOfProductsSlice.actions
